import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Constants from 'root/constants';
import View from 'view/base';
import Cache from 'root/cache';
import Tooltip from 'root/module/tooltip';
import Util from 'root/module/util';

const feedback_type_translation = {
    [Constants.FEEDBACK_GENERAL]:         'General',
    [Constants.FEEDBACK_BUG]:             'Bug',
    [Constants.FEEDBACK_FEATURE_REQUEST]: 'Idea'
};

export default View.extend({
    className: 'inbox-notification',

    events: {
        'click'                   : 'onOpen',
        'click :checkbox'         : 'onSelect',
        'mouseleave'              : 'onMouseLeave',
        'click .edit-read'        : 'onRead',
        'click .edit-unread'      : 'onUnread',
        'click .edit-delete'      : 'onDelete',
        'click .unsnooze'         : 'onUnsnooze',
        'click .snooze-later'     : 'onSnoozeLater',
        'click .snooze-tomorrow'  : 'onSnoozeTomorrow',
        'click .snooze-next-week' : 'onSnoozeNextWeek'
    },

    dom_handlers: {
        onOpen: function(e) {
            if ($(e.target).hasClass('stop-propagation') || $(e.target).parents('.stop-propagation').length) {
                return;
            }

            // ignore click on checkbox
            if ($(e.target).prop('tagName') === 'INPUT' || $(e.target).prop('tagName') === 'LABEL') {
                return;
            }

            this.trigger('open', this.model);
        },

        onSelect: function(e) {
            this.trigger('select', this.model, $(e.currentTarget).prop('checked') ? true : false);
        },

        onMouseLeave: function () {
            this.$el.find('.button-dropdown-actions > div').hide();
        },

        onRead: function(e) {
            this.update({
                is_read: true
            });

            UI.success('Notification marked as read');
        },

        onUnread: function(e) {
            this.update({
                is_read: false
            });

            UI.success('Notification marked as unread');
        },

        onDelete: function(e) {
            Cache.app.request({
                action: 'inbox/delete',
                data: {
                    ids: [this.model.get('id')]
                },
                success: () => {
                    Tooltip.removeAll();

                    Cache.inbox_notification.remove(this.model);
                    UI.success('Notification deleted', 10, false, { // give people 10 seconds to undo
                        text: 'Undo',
                        onclick: () => {
                            Cache.inbox_notification.add(this.model);
                            UI.removeMessages();

                            this.update({
                                delete_time: 0
                            });
                        }
                    });
                }
            });
        },

        onUnsnooze: function(e) {
            this.update({
                snooze_offset : 0
            });

            UI.success('Notification unsnoozed!');
        },

        onSnoozeLater: function(e) {
            this.update({
                snooze_offset: 2 * 60 * 60
            });

            UI.success('Notification snoozed for 2 hours');
        },

        onSnoozeTomorrow: function(e) {
            this.update({
                snooze_offset: 'tomorrow'
            });

            UI.success('Notification snoozed until tomorrow');
        },

        onSnoozeNextWeek: function(e) {
            this.update({
                snooze_offset: 'next_monday'
            });

            UI.success('Notification snoozed until next week');
        }
    },

    update: function(attributes) {
        Cache.app.request({
            action: 'inbox/update',
            data: {
                notifications: [
                    {id: this.model.get('id'), ...attributes}
                ]
            },
            success: (response) => {
                // some model attributes are updated on the server side
                // so sync the model with the server response
                if (response[this.model.id]) {
                    this.model.set(response[this.model.id]);
                }
            }
        });
    },

    initialize: function() {
        // read/unread, summary...etc change
        this.listenTo(this.model, 'change', this.render);
    },

    select: function(selected) {
        if (selected) {
            if (this.$el.find(':checkbox').is(':checked')) {
                return;
            }
        } else {
            if (!this.$el.find(':checkbox').is(':checked')) {
                return;
            }
        }

        this.$el.find(':checkbox').trigger('click');
    },

    getCommentText: function() {
        try {
            var comment_data = JSON.parse(this.model.get('comment_data'));
            var current_user = Cache.user.get(comment_data.current_user_id);
            var current_user_name = current_user ? current_user.get('name') : '';
            var to_user = Cache.user.get(comment_data.to_user_id);
            var to_user_name = to_user ? to_user.get('name') : '';

            if (comment_data.to_user_id === Cache.real_user_id) {
                to_user_name = 'you';
            }

            if ((!current_user_name)) {
                current_user_name = comment_data.name || comment_data.email || comment_data.integration || '';
            }

            switch (comment_data.type) {
                case 'feedback_assign':
                    if (comment_data.to_user_id === 0) {
                        return 'Unassigned by ' + current_user_name;
                    } else {
                        return current_user_name + ' assigned to ' + to_user_name;
                    }
                case 'feedback_create':
                    var feedback_type = 'feedback';
                    switch (comment_data.feedback_type) {
                        case Constants.FEEDBACK_GENERAL:
                            feedback_type = 'general feedback';
                            break;
                        case Constants.FEEDBACK_BUG:
                            feedback_type = 'bug';
                            break;
                        case Constants.FEEDBACK_FEATURE_REQUEST:
                            feedback_type = 'idea';
                            break;
                    }

                    if (current_user_name) {
                        return 'New ' + feedback_type + ' created by ' + current_user_name;
                    } else {
                        return 'New ' + feedback_type + ' received';
                    }
                case 'feedback_edit':
                    return 'Feedback edited by ' + current_user_name;
                case 'feedback_workflow':
                    return 'Status set as ' + Util.cap(comment_data.workflow_name) + ' by ' + current_user_name;
                case 'feedback_priority':
                    return 'Priority set as ' + Util.cap(comment_data.priority) + ' by ' + current_user_name;
                case 'feedback_move':
                    var old_project = Cache.project.get(comment_data.old_project_id);
                    var old_project_name = old_project ? old_project.get('name') : '';

                    return 'Feedback moved' + (old_project ? ' from ' + old_project_name : '') + ' by ' + current_user_name;
                case 'feedback_unmerge':
                    // Depends on UI, could be primary feedback id/name
                    return '';
                case 'feedback_merge':
                    // Depends on UI, could be number of tickets
                    return '';
                case 'feedback_type':
                    return 'Feedback type set as ' + feedback_type_translation[comment_data.feedback_type] + ' by ' + current_user_name;
                case 'feedback_category':
                    return 'Feedback category updated by ' + current_user_name;
                case 'feedback_vote':
                    return 'Feedback received a new vote';
                case 'feedback_comment_add':
                    return 'New comment added by ' + current_user_name;
                case 'feedback_comment_edit':
                    return 'Comment edited by ' + current_user_name;
                case 'survey_response':
                    return 'New survey response';
                case 'feedback_due':
                    return 'Feedback is overdue';
                case 'feedback_due_reminder':
                    return 'Feedback is due soon';
                case 'feedback_due_date_changed':
                    if (comment_data.due_date === 0) {
                        return 'Due date removed by ' + current_user_name;
                    }
                    return 'Due date changed to ' + Util.moment(comment_data.due_date, 'DD MMM YYYY', false, false) + ' by ' + current_user_name;
                case 'snooze':
                    // TODO: This is optional - we can pass this when unsnoozed, or leave the previous comment
                    return 'Unsnooze!';
            }
        } catch(e) {
            // invalid json
        }

        return '';
    },

    getSummaryText: function() {
        if (this.model.get('summary')) {
            return this.model.get('summary');
        } else if (this.model.get('object_type') === 'feedback') {
            return 'Untitled';
        } else {
            return 'Unknown';
        }
    },

    render: function() {
        var project_model = Cache.project.get(this.model.get('project_id'));
        var uid = _.uniqueId('notification_');
        var is_selected = this.$el.find(':checkbox').is(':checked'); // restore previous state
        var is_overdue = false;

        try {
            var comment_data = JSON.parse(this.model.get('comment_data'));
            if (comment_data.type === 'feedback_due') {
                is_overdue = true;
            }
        } catch(e) {
        }

        var content =
        '<div>' +
            '<input type="checkbox" value="' + this.model.get('id') + '" id="' + uid + '">' +
            '<label for="' + uid + '"></label>' +
        '</div>' +
        '<div>' +
            '<div class="action-btns">' +
                (this.model.get('is_read') ?
                '<button type="button" class="edit-unread tertiary small square round stop-propagation tooltip" data-title="Mark as unread"><i class="fa-solid fa-envelope-open"></i></button>' :
                '<button type="button" class="edit-read tertiary small square round stop-propagation tooltip" data-title="Mark as read"><i class="fa-solid fa-envelope-dot"></i></button>') +
                '<button type="button" class="edit-delete tertiary small square round stop-propagation tooltip" data-title="Delete"><i class="fa-solid fa-trash"></i></button>' +
                '<div class="button-dropdown button-dropdown-actions">' +
                    '<button type="button" class="tertiary small square round stop-propagation tooltip" data-title="Snooze"><i class="fa-solid fa-clock"></i></button>' +
                    '<div>' +
                        '<ul class="dropdown">' +
                            (this.model.get('snooze_time') ?
                            '<li class="unsnooze stop-propagation">Unsnooze notification</li>' +
                            '<li class="separator"></li>' : '') +
                            '<li class="dropdown-title margin-left-0">Snooze until...</li>' +
                            '<li class="snooze-later stop-propagation"><div class="flex-between"><span>Later</span><span class="text-info margin-left-24">in 2 hours</span></div></li>' +
                            '<li class="snooze-tomorrow stop-propagation"><div class="flex-between"><span>Tomorrow</span><span class="text-info margin-left-24">' + Util.getTomorrow('ddd HH:mm') + '</span></div></li>' +
                            '<li class="snooze-next-week stop-propagation"><div class="flex-between"><span>Next week</span><span class="text-info margin-left-24">' + Util.getNextMonday('ddd HH:mm') + '</span></div></li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="flex-between">' +
                '<div class="notification-title"><span>' + Util.htmlEntities(this.getSummaryText()) + '</span></div>' +
                '<div class="notification-time">' + Util.moment(this.model.get('notification_time'), 'MMM DD') + '</div>' +
            '</div>' +
            '<div class="notification-summary">' + Util.htmlEntities(this.getCommentText()) + '</div>' +
            (this.model.get('object_type') === 'feedback' ?
            '<div class="project-info">' +
                '<div class="tooltip" data-title="Project: ' + project_model.escape('name') + '">' + project_model.escape('name') + '</div>' +
            '</div>' : '') +
            (this.model.get('snooze_time') ?
            '<div class="snooze-time"><span class="tooltip" data-title="Snoozed until ' + Util.moment(this.model.get('snooze_time'), 'DD MMM YYYY HH:mm A', null, false) + '"><i class="fa-regular fa-alarm-clock"></i> ' + Util.moment(this.model.get('snooze_time'), 'DD MMM YYYY HH:mm A', null, false) + '</span></div>' : '') +
        '</div>';
        this.$el.html(content);
        this.$el.attr('data-read', this.model.get('is_read') ? 1 : 0);
        this.$el.attr('data-overdue', is_overdue ? 1 : 0);

        if (is_selected) {
            this.$el.find(':checkbox').prop('checked', true);
        }

        return this;
    }
});